import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { ButtonColor, ButtonSize } from '@freelancer/ui/button';

@Component({
  standalone: false,
  selector: 'fl-section-article-button',
  template: `
    <fl-button
      class="SectionArticleButton"
      [color]="color"
      [size]="ButtonSize.LARGE"
      [sizeDesktop]="ButtonSize.XLARGE"
      [link]="link"
      [queryParams]="queryParams"
    >
      <ng-content></ng-content>
    </fl-button>
  `,
  styleUrls: ['./section-article-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SectionArticleButtonComponent {
  ButtonSize = ButtonSize;

  @Input() color: ButtonColor = ButtonColor.DEFAULT;
  @Input() link: string;
  @Input() queryParams?: { [k: string]: any };
}
